import React from 'react';
import { Colors } from '../../../constants/colors.constants';
import { CraneXmarkIcon } from '../../../icons';
import EmptyStateSystem from '../../../components/DesignSystem/EmptyStateSystem';
import { getHeightSchedule } from '../project.helper';
import { useTranslation } from 'react-i18next';

export default function EmptyHome() {
  const { t } = useTranslation();
  const { DARK_GRAY } = Colors;
  const description = t('projects.empty_state_message.no_project_assigned');
  return (
    <div
      style={{
        height: getHeightSchedule()
      }}>
      {EmptyStateSystem({
        icon: <CraneXmarkIcon color={DARK_GRAY} />,
        description
      })}
    </div>
  );
}
